module.exports = __webpack_public_path__ + "static/img/app3.7385fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app3.jpg
// module id = f5Di
// module chunks = 0